import React, { useContext } from 'react'
import { useIntl } from 'react-intl'

// utils
import { PAGE_LINKS } from '../../../../utils/helper'
import { MyLocationContext } from '../../../../utils/myLocationProvider'
import { getHomePageShowSalonsClickEvent } from '../../../../utils/dataLayerEvents'
import { pushToDataLayer } from '../../../../utils/dataLayer'

// types
import { CategoriesResponse, CmsHomepageData } from '../../../../types/types'

// styles
import * as SC from './DiscoverServiceSectionSectionStyles'
import { HomePageContainer, HomePageSectionLink } from '../../HomePageStyles'

// hooks
import useMessages from '../../../../hooks/useMessages'

type Props = {
	categoriesData: CategoriesResponse
	cmsData: CmsHomepageData['discoverServiceData']
}

// component
const DiscoverServiceSection = (props: Props) => {
	const { locale } = useIntl()
	const { messages } = useMessages()
	const { myLocation } = useContext(MyLocationContext)

	const { categoriesData, cmsData } = props
	const { title, subtitle } = cmsData

	const sectionLink = PAGE_LINKS['/salons/all'](locale, { ...myLocation })

	return (
		<section>
			<HomePageContainer>
				<SC.Layout>
					<SC.InfoCol>
						<SC.SectionTitle $marginBottom={'16px'}>{title}</SC.SectionTitle>
						<SC.SectionDescription $marginBottom={'16px'}>{subtitle}</SC.SectionDescription>
						<HomePageSectionLink
							href={sectionLink}
							aria-label={messages['discover-service-section-link-aria-label']}
							onClick={() => pushToDataLayer(getHomePageShowSalonsClickEvent('discover_services', sectionLink))}
						>
							{messages['discover-service-section-link']}
						</HomePageSectionLink>
					</SC.InfoCol>
					<SC.ServicesCol>
						<SC.ServicesGrid>
							{categoriesData.categories.map((category) => (
								<SC.TopLevelCategoryButton
									type='button'
									href={PAGE_LINKS['/salons/all/:categorySlug'](locale, category.seoSlug || category.id, { ...myLocation })}
									key={category.id}
								>
									<SC.TopLevelCategoryImgWrapper>
										<SC.TopLevelCategoryImg src={category.image?.resizedImages.thumbnail} alt='' loading='lazy' width={80} height={80} />
									</SC.TopLevelCategoryImgWrapper>
									<SC.TopLevelCategoryTitle>{category.name}</SC.TopLevelCategoryTitle>
								</SC.TopLevelCategoryButton>
							))}
						</SC.ServicesGrid>
					</SC.ServicesCol>
				</SC.Layout>
			</HomePageContainer>
		</section>
	)
}

export default DiscoverServiceSection
